import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNotepad: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNotepad"><Path d="M20 3.05566H4V21.0001H20V3.05566Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 9.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 13.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 4V2.25" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 4V2.25" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 4V2.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconNotepad;
